import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
    static targets = ["tab", "panel"]
    static classes = ["active", "inactive"]

    connect() {
        this.showTab(0)
    }

    change(event) {
        const index = this.tabTargets.indexOf(event.currentTarget)
        this.showTab(index)
    }

    showTab(index) {
        this.panelTargets.forEach((panel, i) => {
            panel.classList.toggle("hidden", i !== index)
        })

        this.tabTargets.forEach((tab, i) => {
            if (i === index) {
                tab.classList.add(...this.activeClasses)
                tab.classList.remove(...this.inactiveClasses)
            } else {
                tab.classList.remove(...this.activeClasses)
                tab.classList.add(...this.inactiveClasses)
            }
        })
    }
}
